<template>
  <div>
    <div v-if="list.length > 0">
      <person-vacation-list-web :list="list" class="hidden-sm-and-down" />
      <person-vacation-list-mob :list="list" class="hidden-md-and-up" />
    </div>
    <div v-else>
      <EmptyList />
    </div>
  </div>
</template>

<script>
import PersonVacationListMob from "../periodDetails/PersonVacationList/PersonVacationListMob.vue";
import PersonVacationListWeb from "../periodDetails/PersonVacationList/PersonVacationListWeb.vue";

export default {
  components: { PersonVacationListWeb, PersonVacationListMob },

  props: {
    perno: String,
    date: String,
  },
  mounted() {
    this.getPersonVacationList();
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    getPersonVacationList() {
      const params = new URLSearchParams();
      params.append("beginDate", this.date);
      params.append("endDate", this.date);
      params.append("searchKind", "10");
      params.append("perno", this.perno);

      this.$store.dispatch("PersonVacationList", { params }).then((result) => {
        if (result.type === "success") {
          this.list = result.data;
        }
      });
    },
  },
};
</script>

<style>
</style>